import { render, staticRenderFns } from "./registrateModal.vue?vue&type=template&id=70013740"
import script from "./registrateModal.vue?vue&type=script&scoped=true&lang=js"
export * from "./registrateModal.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./registrateModal.vue?vue&type=style&index=0&id=70013740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports